import { DialogRef, DIALOG_DATA } from '@angular/cdk/dialog';
import { Component, inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from '../../../core/user/user.service';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-notifications-modal',
  templateUrl: './notifications-modal.component.html',
  styleUrls: ['./notifications-modal.component.css'],
  standalone: true,
  imports: [MatIconModule, CommonModule],
})
export class NotificationsModalComponent implements OnInit {
  dialogRef = inject(DialogRef);
  datax = inject(DIALOG_DATA);
  notifications: any[] = [];
  currentPage = 1;
  pageSize = 20;
  loadingMore = false;
  totalNotifications = 0;
  constructor(private router: Router, private _userService: UserService) {}

  ngOnInit() {
    this._userService.clearNotifications();

    this._userService.notifications$.subscribe((notifications) => {
      this.notifications = notifications;
    });

    this.loadNotifications();
  }

  loadNotifications() {
    this.loadingMore = true;
    this._userService
      .getNotifications(this.currentPage, this.pageSize)
      .subscribe((response: any) => {
        const data = response?.payload;

        this.totalNotifications = data.pagination.total;
        this.currentPage++;
        this.loadingMore = false;
      });
  }

  handleAction(notification: any) {
    const { open, moviment } = notification.action;

    this._userService.markNotificationAsRead(notification._id).subscribe(() => {
      notification.read = true;

      switch (open) {
        case 'browser':
          window.open(moviment, '_blank');
          break;
        case 'artists':
          this.router.navigate(['/artists']);
          break;
        case 'artist':
          this.router.navigate(['/artist', moviment]);
          break;
        case 'works-of-art':
          this.router.navigate(['/worksofart']);
          break;
        case 'work-of-art':
          this.router.navigate([], {
            queryParams: { workOfArtId: moviment },
            queryParamsHandling: 'merge', // merge with existing query params
            replaceUrl: true,
          });
          break;
        case 'onDemand':
          this.router.navigate(['/on-demand', moviment]);
          break;
        default:
          break;
      }

      this.dialogRef.close(); // opcional
    });
  }

  closeModal() {
    this.dialogRef.close();
  }

  deleteNotification(notification: any) {
    this._userService.deleteNotification(notification._id).subscribe(() => {
      this.totalNotifications--;
    });
  }
}
